import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })

export class CourseInstanceConstants {
  EFL = 'EFL';
  General = 'General';
  studyLevel = 'studyLevel';
  qualificationTypeGroup = 'qualificationTypeGroup';
  qualificationType = 'qualificationType';
  courseCodeType = 'courseCodeType';
  courseInstanceTitle = 'courseInstanceTitle';
  beginnerAccepted = 'beginnerAccepted';
  courseInstanceCodeTypeValues = 'courseInstanceCodeTypeValues';
  courseInstanceChannels = 'courseInstanceChannels';
  academicYear = 'academicYear';
  courseType = 'courseType';
  optional = 'N';
  mandatory = 'Y';
  courseError = 'Please fill the course form to view the instance page.';
  instanceError = 'You have not completed the current instance. Please fill in all the details before adding a new instance';
  department = 'department';
  courseInstanceURLs = 'courseInstanceURLs';
  courseInstanceError = 'Please save the course instance form to view the course page.';
  courseInstanceURLsFields = ['courseInstanceUrl', 'admissionProcessInfoUrl', 'offerAcceptanceInfoUrl', 'creditTransferFormUrl', 'pgsApplyNowUrl', 'pgsCourseUrl', 'whatuniCourseUrl', 'cugCourseUrl', 'ucasCourseUrl'];
  channelFlags = ['Display Flag', 'Business Flag', 'Contract Flag'];
  radioButtonOptions = ['Yes', 'No'];
  eflFlags = ['Display Flag'];
  courseInstanceDomERFields = ['domesticAcademicDescription', 'ucasTarrifPoints', 'ucasSecretTarrifPoints', 'domesticWorkExperienceDescription', 'domesticEntryRequirementURL'];
  courseInstanceIntlERFields = ['internationalAcademicDescription', 'caoPoints', 'englishLanguageDescription', 'internationalWorkExperienceDescription', 'internationalEntryRequirementURL'];
  entryRequirements = 'entryRequirements';
  subjects = 'subjects';
  legacyIDPsubject = 'legacyIdpSubjects';
  legacyIDPCsubject = 'legacyIdpcSubjects';
  subjectFields = [this.subjects, this.legacyIDPsubject, this.legacyIDPCsubject];
  // Hard Coded ref
  studentTypeRefIds = [
    { studentTypeId: 1, displayName: 'Domestic' },
    { studentTypeId: 2, displayName: 'International' }
  ];
  courseInstanceCodeRestrict: any = {
    4: { minLength: 7, maxLength: 40 }  // CRICOS
  }
  courseCodeRestrict: any = {
    3: { minLength: 4, maxLength: 4 }, // UCAS
    7: { minLength: 5, maxLength: 5 },  // CAO
    14: { minLength: 5, maxLength: 15, characterValidation: "a-zA-Z0-9/" }, // MQA
    15: { minLength: 4, maxLength: 6, characterValidation: '0-9' }, // CAA
  }
  CKEditorFields = ['courseDescription', 'courseOutcome', 'courseMajorSubject', 'domesticAcademicDescription', 'domesticWorkExperienceDescription', 'internationalAcademicDescription', 'englishLanguageDescription', 'internationalWorkExperienceDescription', 'keywords'];
  instanceAttributeIds = {
    applicableToStudyBCAttrId: 39,
    internshipAvailable: 2,
    bcCourseInstanceTitle: 33,
    bridgingAvailableAttrId: 1,
    pgwpEligible: 42,
    hecosCodeAttrId: 43,
    hecosCodeDescAttrId: 44,
    hecosWeightingAttrId: 45,
    cnCourseTitle: 38,
    taughtInWelsh: 47,
    englishTitle: 46
  };
  instanceStudyBCAttrIds = [33, 34, 35, 36, 39];
  studyAbroadAvailable = 'studyAbroadAvailable';
  studyAbroadDescription = 'studyAbroad';
  courseDuration = 'courseDuration';
  duplicateInstanceMsg = 'The course instance courseInstanceTitle is successfully duplicated';
  courseTitle = 'courseTitle';
  cipCode = 'cipCode';
  cipCodeTypeId = 13;
  hideStudyBCId = 4;
  businessLineFlags = [{ id: 'SP', name: 'Student placement', hideAlert: true, disableFlag: false }, { id: 'DM', name: 'Digital marketing', hideAlert: true, disableFlag: false }, { id: 'BOTH', name: 'Both', hideAlert: true, disableFlag: false }]
  businessLine = 'businessLine';

  clearingAvailableFilterOptions = [
    {
      "id": "true",
      "name": "Applicable"
    },
    {
      "id": "false",
      "name": "Not applicable"
    }
  ]
  charValidationCIRCOS = "exact^[a-zA-Z0-9,]+$";
  instanceCodeCRICOS = "CRICOS";
  clearingStudylevelMismatchMsg = "This course can’t be saved as a Clearing course unless it’s an undergraduate course in the UK.";
  ugStudylevelId = 5;
  taughtInWelshAttrOptYesId = 47;
}